export default "/build/images/4foot.png?88ca4b1a82102703df6b54830b5ac14a";